"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Collapse = _interopRequireDefault(require("../Collapse/Collapse"));
var _ComponentVerticalSpacing = _interopRequireDefault(require("../helpers/ComponentVerticalSpacing"));
var _ComponentWrapper = _interopRequireDefault(require("../helpers/ComponentWrapper"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _LoadingView = _interopRequireDefault(require("../../LoadingView"));
var _api = require("../../content/api");
var _colors = require("../constants/colors");
var _envConstants = require("../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FaqList = function FaqList(_ref) {
  var categoryTitle = _ref.categoryTitle,
    index = _ref.index,
    text = _ref.text,
    onLoad = _ref.onLoad,
    faqs = _ref.faqs,
    categorySlug = _ref.categorySlug,
    singleCat = _ref.singleCat;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loadedFaqs = _useState2[0],
    setLoadedFaqs = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    noResults = _useState6[0],
    setNoResults = _useState6[1];
  (0, _react.useEffect)(function () {
    if (faqs !== null && faqs !== void 0 && faqs.length) {
      setLoadedFaqs(faqs);
      setLoading(false);
    } else {
      setFaqs(categorySlug, singleCat);
    }
  }, [faqs]);
  var setFaqs = function setFaqs(categorySlug, singleCat) {
    return (0, _api.getFaqArticles)(1, categorySlug, undefined, singleCat ? 30 : 9).then(function (res) {
      if (res === null) {
        setNoResults(true);
        setLoading(false);
      }
      setLoadedFaqs(res.posts);
      setLoading(false);
    });
  };
  if (loading) {
    if (index === 0) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _envConstants.ENV.SITE === 'tyw' ? /*#__PURE__*/_react["default"].createElement(_LoadingView["default"], null) : /*#__PURE__*/_react["default"].createElement(_LoadingView["default"], {
        icon: "snow",
        fill: "#00a8a3"
      }));
    }
    return null;
  }
  if (onLoad) onLoad();
  if (noResults) {
    return /*#__PURE__*/_react["default"].createElement(_ComponentVerticalSpacing["default"], null, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("h2", {
      className: "margin-bottom-md text-center"
    }, categoryTitle), text && /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-center margin-bottom-md"
    }, text), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-center"
    }, "Ops, looks like there are no FAQ items for `", categoryTitle, "`")));
  }
  return /*#__PURE__*/_react["default"].createElement(_ComponentVerticalSpacing["default"], null, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-width-xs margin-auto"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "margin-bottom-md text-center"
  }, categoryTitle, " "), text && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center margin-bottom-md"
  }, text), !!(loadedFaqs !== null && loadedFaqs !== void 0 && loadedFaqs.length) && loadedFaqs.map(function (post) {
    return /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      key: JSON.stringify(post.id),
      heading: post.title.rendered
    }, /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: post.content.rendered
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      className: "icon--md margin-top-sm",
      href: "/faq/".concat(post.slug)
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      fill: _colors.COLORS.PRIMARY,
      name: "link"
    }))));
  }), !(loadedFaqs !== null && loadedFaqs !== void 0 && loadedFaqs.length) && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center"
  }, "Ops, looks like there are no FAQ items for `", categoryTitle, "`"))));
};
FaqList.propTypes = {
  categorySlug: _propTypes["default"].string,
  categoryTitle: _propTypes["default"].string,
  singleCat: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  text: _propTypes["default"].string,
  onLoad: _propTypes["default"].func
};
FaqList.defaultProps = {
  onLoad: function onLoad() {}
};
var _default = exports["default"] = FaqList;